import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';

// Sign-in is GitHub only. The backend resolver refuses anyone without a User
// entity in the catalog, and those entities come from the tepapaatawhai org
// membership sync, so a GitHub account outside the org cannot get in.
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: any) =>
      (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in with your DOC GitHub account',
            apiRef: githubAuthApiRef,
          }}
        />
      ) as any,
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
